import {
  Document,
  PDFViewer,
  Page as PDFPage,
  StyleSheet,
  Text as PDFText,
  View as PDFView,
  Image as PDFImage
} from '@react-pdf/renderer';
import { dateFormatter } from '../../../../../utils';

const styles = StyleSheet.create({
  page: {
    padding: 20
  },
  heading: {
    fontSize: 18,
    textAlign: 'center',
    marginBottom: 20
  },
  line: {
    height: 0.6,
    backgroundColor: 'black',
    marginVertical: 10,
    marginTop: '40px'
  },
  line2: {
    height: 0.4,
    backgroundColor: 'black',
    marginVertical: 10
  },
  contentContainer: {
    display: 'flex',
    flexDirection: 'row',
    justifyContent: 'space-between',
    marginTop: 0,
    marginBottom: 0,
    border: '1px Solid black',
    padding: '10px'
  },
  contentContainer2: {
    display: 'flex',
    flexDirection: 'row',
    justifyContent: 'space-between',
    marginTop: 0,
    marginBottom: 0
  },
  column: {
    flex: 1,
    paddingHorizontal: 10
  },
  row: {
    flexDirection: 'row'
  },
  text: {
    fontSize: 9,
    display: 'inline-block'
  },
  textBold: {
    fontSize: 9,
    fontWeight: 'bold'
  },
  textUnderlined: {
    textDecoration: 'underline'
  },

  columnHeader: {
    width: '15%',
    backgroundColor: 'navy',
    color: 'white',
    padding: 5,
    textAlign: 'center',
    marginTop: '2%'
  },
  tableCell: {
    fontSize: 10
  },
  columnContent: {
    width: '15%',
    padding: 6,
    textAlign: 'center',
    alignItems: 'center'
  },
  headerContainer: {
    display: 'flex',
    flexDirection: 'row',
    justifyContent: 'space-evenly',
    padding: 5,
    border: '1px solid black',
    marginTop: 10,
    backgroundColor: 'navy',
    color: 'white'
  },
  columnHeader: {
    width: 'auto'
  },
  columnText: {
    width: '10%',
    textAlign: 'center'
  },
  columnTextWide: {
    width: '17%',
    textAlign: 'center'
  },
  columnTextNarrow: {
    width: '5%',
    textAlign: 'center'
  }
});

const COLORS = ['#f0f0f0', '#e0e0e0'];

const Page = ({ style, children, ...props }) => (
  <PDFPage style={{ ...styles.page, ...style }} {...props}>
    {children}
  </PDFPage>
);

const View = ({ style, children, ...props }) => (
  <PDFView style={{ ...style }} {...props}>
    {children}
  </PDFView>
);

const Text = ({ style, content, ...props }) => (
  <PDFText style={{ ...styles.text, ...style }} {...props}>
    {content}
  </PDFText>
);

export const OpdRequisitionProgressReportPdf = ({ data }) => {
  console.log(data.createdAt);
  return (
    <PDFViewer width="100%" height="100%" showToolbar>
      <Document title={`Opd Requisition Progress Report`}>
        <Page size="A4" style={styles.page}>
          <PDFImage
            src="/logo_Hospital_m.jpeg"
            style={{ width: '100%', height: '80px', marginBottom: 1, marginRight: '10%' }}
          />
          <View style={styles.row}>
            <Text content="OPD Requisition Progress Report" style={{ fontSize: '12px', margin: '0 auto' }} />
          </View>
          <View style={styles.contentContainer}>
            <View style={styles.column}>
              <View style={styles.row}>
                <Text content="UHID NO.                 :" style={styles.textBold} />
                <Text content={`${data.uhid}`} />
              </View>
              <View style={styles.row}>
                <Text content="OPD Date/Time       :" />
                <Text content={`${dateFormatter(data.dateTime)}`} />
              </View>
              <View style={styles.row}>
                <Text content="Address                   :" />
                <Text content={`${data.address}`} />
              </View>
            </View>
            <View style={styles.column}>
              <View style={styles.row}>
                <Text content="Patient Name      : " />
                <Text content={`${data.patientName}`} />
              </View>
              <View style={styles.row}>
                <Text content="Age/Sex              :" />
                <Text content={`${data.age} / ${data.gender}`} />
              </View>
              <View style={styles.row}>
                <Text content="Mobile                 :" />
                <Text content={`${data.mobile}`} />
              </View>
            </View>
            <View style={styles.column}>
              <View style={styles.row}>
                <Text content="Department            :" />
                <Text content={`${data.department}`} />
              </View>
              <View style={styles.row}>
                <Text content="Sponsor                  :" />
                <Text content={`${data.sponsor}`} />
              </View>
              <View style={styles.row}>
                <Text content="Operating Doctor    : " />
                <Text content={`${data.doctor}`} />
              </View>
            </View>
          </View>
          <Text
            content="Vitals"
            style={{ marginTop: '10px', fontSize: '12px', borderBottom: '1px solid black', width: '25%' }}
          />

          {data.vitals &&
            Object.keys(data.vitals).map((vitalKey, index) => {
              const vitalValues = data.vitals[vitalKey].filter((value) => value !== '-').join(', ');
              return vitalValues ? (
                <View key={index} style={{ ...styles.row }}>
                  <Text content={`${vitalKey.charAt(0).toUpperCase() + vitalKey.slice(1)} -`} />
                  <Text content={`${vitalValues}`} />
                </View>
              ) : null;
            })}
          <View style={styles.headerContainer}>
            <Text content="S. No." style={{ ...styles.columnText, width: '10%' }} />
            <Text content="Complaints" style={{ ...styles.columnText, width: '30%' }} />
            <Text content="Duration" style={{ ...styles.columnText, width: '30%' }} />
            <Text content="Date" style={{ ...styles.columnText, width: '30%' }} />
          </View>
          {data.complaints &&
            data.complaints.map((item, index) => (
              <View
                style={{
                  ...styles.row,
                  backgroundColor: index % 2 !== 0 ? '#ffffff' : '#f7f7f7',
                  padding: '2px'
                }}
                key={index}
              >
                <Text content={index + 1} style={{ ...styles.columnText, width: '10%' }} />
                <Text content={item.complaints || '-'} style={{ ...styles.columnText, width: '30%' }} />
                <Text content={item.duration || '-'} style={{ ...styles.columnText, width: '30%' }} />
                <Text
                  content={dateFormatter(item.createdAt) || '-'}
                  style={{ ...styles.columnText, width: '30%' }}
                />{' '}
                {/* Accessing data.createdAt directly */}
              </View>
            ))}
          <View style={styles.headerContainer}>
            <Text content="S. No." style={{ ...styles.columnText, width: '10%' }} />
            <Text content="Diagnos" style={{ ...styles.columnText, width: '45%' }} />
            <Text content="Date" style={{ ...styles.columnText, width: '45%' }} />
          </View>
          {data.diagnos &&
            data.diagnos.map((item, index) => (
              <View
                style={{
                  ...styles.row,
                  backgroundColor: index % 2 !== 0 ? '#ffffff' : '#f7f7f7',
                  padding: '2px'
                }}
                key={index}
              >
                <Text content={index + 1} style={{ ...styles.columnText, width: '10%' }} />
                <Text content={item.add_diagnos || '-'} style={{ ...styles.columnText, width: '60%' }} />
                <Text
                  content={dateFormatter(item.createdAt) || '-'}
                  style={{ ...styles.columnTextNarrow, width: '30%' }}
                />
              </View>
            ))}
          <View style={styles.headerContainer}>
            <Text content="S. No." style={styles.columnTextNarrow} />
            <Text content="Type" style={{ ...styles.columnText, width: '20%' }} />
            <Text content="Doctor" style={styles.columnTextWide} />
            <Text content="Service Name " style={{ ...styles.columnText, width: '20%' }} />
            <Text content="Qty" style={styles.columnText} />
            <Text content="Rate" style={styles.columnText} />
            <Text content="Amount" style={styles.columnText} />
            <Text content="Net Amt" style={styles.columnText} />
            <Text content="Date" style={styles.columnText} />
          </View>
          {data.service_items &&
            data.service_items.map((item, index) => (
              <View
                style={{
                  ...styles.row,
                  backgroundColor: index % 2 !== 0 ? '#ffffff' : '#f7f7f7',
                  padding: '2px'
                }}
                key={index}
              >
                <Text content={index + 1} style={{ ...styles.columnTextNarrow }} />
                <Text content={item.type || '-'} style={{ ...styles.columnText, width: '20%' }} />
                <Text content={item.doctor || '-'} style={{ ...styles.columnText, width: '22%' }} />
                <Text content={item.service_name || '-'} style={styles.columnText} />
                <Text content={item.quantity || '-'} style={styles.columnText} />
                <Text content={item.rate || '-'} style={{ ...styles.columnText }} />
                <Text content={item.amount || '-'} style={{ ...styles.columnText }} />
                <Text content={item.net_amt || '0'} style={{ ...styles.columnText }} />
                <Text content={dateFormatter(item.createdAt) || '-'} style={{ ...styles.columnText }} />
              </View>
            ))}

          <View style={{ ...styles.headerContainer, marginTop: '2%' }}>
            <Text content="S. No." style={{ ...styles.columnTextNarrow, width: '10%' }} />
            <Text content="Medicine Name" style={{ ...styles.columnText, width: '20%' }} />
            <Text content="Unit" style={{ ...styles.columnTextWide, width: '10%' }} />
            <Text content="Qty" style={{ ...styles.columnText, width: '10%' }} />
            <Text content="Frequency" style={{ ...styles.columnTextWide, width: '20%' }} />
            <Text content="Days" style={{ ...styles.columnText, width: '10%' }} />
            <Text content="Morning" style={{ ...styles.columnText, width: '10%' }} />
            <Text content="Noon" style={{ ...styles.columnText, width: '10%' }} />
            <Text content="Evening" style={{ ...styles.columnText, width: '10%' }} />
            <Text content="Night" style={{ ...styles.columnText, width: '10%' }} />
            <Text content="Duration" style={{ ...styles.columnText, width: '10%' }} />
            <Text content="Date" style={{ ...styles.columnText, width: '10%' }} />
          </View>
          {data.medicine &&
            data.medicine.map((item, index) => (
              <View
                style={{
                  ...styles.row,
                  backgroundColor: index % 2 !== 0 ? '#ffffff' : '#f7f7f7',
                  padding: '2px'
                }}
                key={index}
              >
                <Text content={index + 1} style={{ ...styles.columnTextNarrow, width: '10%' }} />
                <Text content={item.medicine_name || '-'} style={{ ...styles.columnText, width: '20%' }} />
                <Text content={item.unit || '-'} style={{ ...styles.columnText, width: '10%' }} />
                <Text content={item.quantity || '-'} style={{ ...styles.columnText, width: '10%' }} />
                <Text content={item.frequency || '-'} style={{ ...styles.columnTextWide, width: '20%' }} />
                <Text
                  content={item.morning === 'true' ? 'YES' : '' || ''}
                  style={{ ...styles.columnText, width: '10%' }}
                />
                <Text
                  content={item.noon === 'true' ? 'YES' : '' || ''}
                  style={{ ...styles.columnText, width: '10%' }}
                />
                <Text
                  content={item.evening === 'true' ? 'YES' : '' || ''}
                  style={{ ...styles.columnText, width: '10%' }}
                />
                <Text
                  content={item.night === 'true' ? 'YES' : '' || ''}
                  style={{ ...styles.columnText, width: '10%' }}
                />
                <Text content={item.days || '0'} style={{ ...styles.columnText, width: '10%' }} />
                <Text content={dateFormatter(item.createdAt) || '-'} style={{ ...styles.columnText, width: '10%' }} />
              </View>
            ))}
        </Page>
      </Document>
    </PDFViewer>
  );
};
